export default (t) => {
    return (values) => {
        let errors = {};

        if (!values.recipient) errors.recipient = t("shippingAddress:validate.recipientRequired");

        return errors;
    }
}